var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShieldCheckmarkOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 49 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16.5L21.6125 28.5L17 23.9813",
    stroke: "#718CC8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9155 10.5347C35.5324 9.03094 32.0665 7.91719 24.4999 4.5C16.9334 7.91719 13.4674 9.03094 5.08429 10.5347C3.56554 34.6059 23.0543 42.9178 24.4999 43.5C25.9455 42.9178 45.4343 34.6059 43.9155 10.5347Z",
    stroke: "#718CC8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldCheckmarkOutline);
export default __webpack_public_path__ + "static/media/shield-checkmark-outline.305697409121c90e6db9c2a0fc880570.svg";
export { ForwardRef as ReactComponent };